import { DisplayField, DisplayLabel } from '@common/components/forms/fields';
import { bsClassJustifyContent } from '@common/types/bootstrap';
import classNames from 'classnames';
import React from 'react';
import { observer } from 'mobx-react';
import { DisplayFieldType } from './types';

export interface IDisplayGroupProps {
  controlid?: string;
  text: string;
  value?: string | boolean | JSX.Element;
  labelRowJustifyClass?: bsClassJustifyContent;
  labelTailElement?: JSX.Element;
  type?: DisplayFieldType;
  fieldClass?: string;
  placeholder?: string;
  parentClass?: string;
  testId?: string;
}

export const DisplayGroup = observer(({
  controlid,
  text,
  value,
  labelTailElement,
  fieldClass,
  parentClass,
  labelRowJustifyClass = 'justify-content-between',
  type = 'text',
  placeholder,
  testId,
}: IDisplayGroupProps) => {
  return (
    <div
      className={classNames(
        'd-flex flex-column displayGroup gap-1',
        parentClass,
      )}
      data-testid={testId}
    >
      <div className={classNames('d-flex flex-row', labelRowJustifyClass)}>
        <DisplayLabel id={controlid} text={text} />
        {labelTailElement}
      </div>
      <DisplayField
        textClass={fieldClass}
        type={type}
        aria-labelledby={controlid}
        value={value}
        placeholder={placeholder}
      />
    </div>
  );
});
